let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("23zUj")).then(() => parcelRequire('32IfQ'));